import { TabsProps } from 'antd';
import { Tabs } from '@/shared/ui';
import { Appearance } from './Appearance';
import { DeleteAccount } from './DeleteAccount';
import { Notifications } from './Notifications';
import { Password } from './Password';
import { PersonalDetails } from './PersonalDetails';

enum TabKeys {
  Details = 'details',
  Password = 'password',
  Notifications = 'notifications',
  Appearance = 'appearance',
  DeleteAccount = 'deleteAccount',
}

const items: TabsProps['items'] = [
  {
    key: TabKeys.Details,
    label: `Personal details`,
    children: <PersonalDetails />,
  },
  {
    key: TabKeys.Password,
    label: `Password`,
    children: <Password />,
  },
  {
    key: TabKeys.Notifications,
    label: `Notifications`,
    children: <Notifications />,
  },
  {
    key: TabKeys.Appearance,
    label: `Appearance`,
    children: <Appearance />,
  },
  {
    key: TabKeys.DeleteAccount,
    label: `Delete account`,
    children: <DeleteAccount />,
  },
];

export const ProfileTabs = () => {
  return (
    <Tabs
      type="line"
      tabPosition="left"
      defaultActiveKey={TabKeys.Details}
      items={items}
    />
  );
};
